module.exports = __webpack_public_path__ + "static/media/tc-logo-white.c91c0bc0.png";